

function Footer () {

    return (<div className="mc-footer uk-text-center uk-padding-small">
        © Silicom Group {new Date().getFullYear()}
    </div>);
}

export default Footer;
